export const aboutHeroImage =
  'https://readdy.ai/api/search-image?query=Ayurvedic%20herbal%20medicine%20manufacturing%20unit%20interior%20with%20clean%20stainless%20steel%20equipment%20and%20rows%20of%20herbal%20powder%20jars%2C%20bright%20airy%20GMP%20facility%20with%20warm%20natural%20light%2C%20green%20plants%20in%20the%20foreground%2C%20professional%20editorial%20photography%20high%20detail&width=1600&height=900&seq=about-hero-unit-01&orientation=landscape';

export const aboutStoryImage =
  'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20herbal%20Ayurvedic%20medicine%20production%20process%20with%20dried%20botanical%20herbs%2C%20mortar%20and%20pestle%20and%20woven%20baskets%20of%20roots%20on%20a%20wooden%20table%2C%20warm%20natural%20light%2C%20clean%20natural%20aesthetic%2C%20editorial%20photography%20with%20soft%20shadows&width=1200&height=900&seq=about-story-process-01&orientation=landscape';

export const aboutStory = [
  'Best Research Pharma is one of the fastest growing Ayurvedic medicine manufacturers and suppliers, based in the heart of Madurai, Tamil Nadu. Since our establishment, we have been engaged in the manufacturing and distribution of authentic Ayurvedic medicines across India.',
  'Our team is a perfect blend of qualified professionals and experienced hands who understand both traditional Ayurveda and the demands of the modern market. This balance has helped us develop new molecules and new formulations that truly serve the people who use them.',
  'As Ayurvedic medicine suppliers, we firmly believe that manufacturing and distributing Ayurvedic medicines is not just a trade but an art. We invest our hearts and minds equally into every formulation, which is why we have grown into one of the leading Ayurvedic capsule manufacturers in India.',
  'Every product leaves our State-licensed, Schedule T GMP-certified unit operating under an ISO 9001:2015 quality management system, so that what reaches our customers is nothing less than the best.',
];

export const aboutHighlights = [
  { id: 'licensed', icon: 'ri-government-line', label: 'State Licensed Unit' },
  { id: 'gmp', icon: 'ri-shield-check-line', label: 'Schedule T GMP Certified' },
  { id: 'iso', icon: 'ri-award-line', label: 'ISO 9001:2015 Certified' },
  { id: 'range', icon: 'ri-flask-line', label: '150+ Formulations' },
];

export const journeyMilestones = [
  {
    id: 'm1',
    year: '1999',
    title: 'The Beginning',
    description:
      'Best Research Pharma was founded in Madurai with a simple belief — authentic Ayurveda, made with care, can change everyday lives.',
  },
  {
    id: 'm2',
    year: '2006',
    title: 'GMP Certified Unit',
    description:
      'Our manufacturing facility earned Schedule T GMP certification, raising the bar for quality, hygiene and consistency.',
  },
  {
    id: 'm3',
    year: '2012',
    title: 'Pan-India Network',
    description:
      'We expanded distribution beyond Tamil Nadu, building a growing network of distributors, stockists and pharmacies across India.',
  },
  {
    id: 'm4',
    year: '2016',
    title: 'ISO 9001:2015',
    description:
      'Our quality management system was certified to ISO 9001:2015, strengthening processes from sourcing to dispatch.',
  },
  {
    id: 'm5',
    year: '2020',
    title: '150+ Formulations',
    description:
      'Our research-driven range grew past 150 herbal formulations spanning capsules, syrups, lehyam, oils, tablets and powders.',
  },
  {
    id: 'm6',
    year: '2024',
    title: '300+ Distributors',
    description:
      'Today we serve 300+ distributors and partners across 18+ states, carrying research-backed Ayurveda to every corner of India.',
  },
];

export const teamMembers = [
  {
    id: 'founder',
    name: 'Solthan Abuthahir',
    role: 'Founder',
    image: 'images/team/solthan-abuthahir.webp',
    note: 'Established Best Research Pharma with a vision to provide trusted Ayurvedic & Siddha healthcare products.',
  },
  {
    id: 'md',
    name: 'S. Harun Rasheed',
    role: 'Managing Director',
    image: 'images/team/s-harun-rasheed.webp',
    note: "Leads the company's growth, operations, quality standards, and market expansion.",
  },
  {
    id: 'ops',
    name: 'S. Dhaha Mohamed',
    role: 'Director Operations',
    image: 'images/team/s-dhaha-mohamed.webp',
    note: 'Leads digital development, branding, marketing, and innovative business initiatives.',
  },
  {
    id: 'manager',
    name: 'A. Nilofar Nisha',
    role: 'Manager',
    image: 'images/team/a-nilofar-nisha.webp',
    note: 'Coordinates day-to-day operations, supports the team, and ensures smooth communication and efficient workflow across departments.',
  },
  {
    id: 'tele',
    name: 'P. Viji',
    role: 'Tele Manager',
    image: 'images/team/p-viji.webp',
    note: 'Leads the telecalling team, manages customer enquiries and follow-ups, and supports sales through effective customer communication.',
  },
];

export const whyChooseUs = [
  {
    id: 'licensed',
    icon: 'ri-government-line',
    title: 'State Licensed Manufacturing',
    description: 'Produced in a fully licensed Ayurvedic unit that follows every regulatory requirement.',
  },
  {
    id: 'gmp',
    icon: 'ri-shield-check-line',
    title: 'Schedule T GMP Certified',
    description: 'Good Manufacturing Practices guarantee hygiene, purity and batch-to-batch consistency.',
  },
  {
    id: 'iso',
    icon: 'ri-award-line',
    title: 'ISO 9001:2015 Quality System',
    description: 'A certified quality management system governs everything from sourcing to dispatch.',
  },
  {
    id: 'research',
    icon: 'ri-microscope-line',
    title: 'Research-Driven Ayurveda',
    description: 'Traditional wisdom combined with modern research to create genuinely effective formulations.',
  },
];

export const manufacturingSteps = [
  {
    id: 's1',
    icon: 'ri-plant-line',
    step: '01',
    title: 'Sourcing & Selection',
    description: 'Only authentic, quality-checked herbs and botanicals make it into our formulations.',
  },
  {
    id: 's2',
    icon: 'ri-scales-3-line',
    step: '02',
    title: 'Processing & Extraction',
    description: 'Classical processing techniques preserve the potency and purity of every ingredient.',
  },
  {
    id: 's3',
    icon: 'ri-flask-line',
    step: '03',
    title: 'Formulation',
    description: 'Our R&D team blends time-tested recipes with research to perfect every product.',
  },
  {
    id: 's4',
    icon: 'ri-shield-check-line',
    step: '04',
    title: 'Quality Control',
    description: 'Each batch is rigorously tested against GMP and ISO quality benchmarks.',
  },
  {
    id: 's5',
    icon: 'ri-truck-line',
    step: '05',
    title: 'Packing & Dispatch',
    description: 'Sealed, labelled and dispatched on time to partners across India.',
  },
];